/* eslint-disable new-cap */
import {cloneDeep} from 'lodash';

export const customValuesVehiclesInventory = (key, value, row) => {
  const dollarUS = Intl.NumberFormat('de-DE');
  if (key.includes('Date')) {
    return value ? value.substring(0, 10) : value;
  }
  if (key === 'available') {
    return value === 'S' ? 'Si' : 'No';
  }
  if (['cif', 'fobValue'].includes(key)) {
    return value ? `$ ${dollarUS.format(value)}` : '';
  }
  if (key === 'observations') {
    return value || 0;
  }
  if (key === 'shipmentText') {
    return value ? value[0] : '';
  }
  return value;
};

const listChasis = (data) => {
  if (Array.isArray(data)) {
    return data.map((line, index) => line.chassis);
  }
  return [data?.chassis];
};

export const generateJson = (data, key, previousValue, newValue, filters) => {
  return {
    'order_number': data?.orderNumber || null,
    'line': data?.line || null,
    'chassis': listChasis(data),
    'previous_value': previousValue,
    'new_value': newValue,
    'field': key,
    'filters': {...filters},
  };
};

const insertRow = (alldata, index, row) => {
  return [...alldata.slice(0, index), row, ...alldata.slice(index + 1)];
};

export const updateItem = (ordersProcessedData, payload, keys) => {
  const indexObject = ordersProcessedData.findIndex(
    (odr) =>
      odr[keys[0]] === payload[keys[0]] && odr[keys[1]] === payload[keys[1]]
  );
  if (indexObject !== -1) {
    const newOrdersProcessedData = cloneDeep(ordersProcessedData);
    const orderLine = {...newOrdersProcessedData[indexObject], ...payload};
    return insertRow(newOrdersProcessedData, indexObject, orderLine);
  }
  return ordersProcessedData;
};
